import { useEffect, useSyncExternalStore } from 'react';

// Counts mounted "Selezione Vincenzo" copies so the Diario page can turn on the VIP screen protection
let count = 0;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());
const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

export const useVipGuardRequest = (active) => {
  useEffect(() => {
    if (!active) return undefined;
    count += 1; emit();
    return () => { count -= 1; emit(); };
  }, [active]);
};

export const useVipGuardActive = () => useSyncExternalStore(subscribe, () => count > 0);
